import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient,HttpContext } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IntegromatService {

  private readonly urlIntegromat = environment.integromatTitan;
  private http = inject(HttpClient);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  
  postTitan(body: any): Observable<String>{
    const url = `${this.urlIntegromat}`;
    return this.http.post<String>(url,body,{ responseType: 'text' as 'json' });
  }

}
